import gql from 'graphql-tag';
import apollo from 'src/features/apolloCustomer';

const mutation = gql`
mutation SignAuth($authId: String!, $code: String!){
  signAuth(authId: $authId, code: $code) {
    id
  }
}`;

function signAuth(authId, code) {
  return apollo.client.mutate({
    variables: {
      authId,
      code,
    },
    mutation,
  }).then((res) => res.data.signAuth);
}

export default signAuth;
